import * as React from "react";
import Link from "next/link";
import { useRouter } from "next/router";
import { portalRoutes } from "@nju/routes";
import { A, Button, Panel, Separator, Text } from "@nju/ui";
import { generalErrorMessage } from "@nju/utils";

export function CancellationError() {
  const { reload } = useRouter();

  const refresh = React.useCallback(() => {
    reload();
  }, [reload]);

  return (
    <Panel>
      <div className="flex items-center flex-col">
        <Text
          align="center"
          size={{
            "@onlyMobile": "l",
            "@fromTablet": "keyM",
          }}
          weight="bold"
        >
          {generalErrorMessage}
        </Text>
        <Separator size="xs" tone="invisible" />
        <div className="flex justify-center">
          <img alt="Portout failed" src="/images/portout-fail.svg" />
        </div>
        <Separator size="xs" tone="invisible" />
        <Text
          align="center"
          size={{
            "@onlyMobile": "m",
            "@fromTablet": "l",
          }}
        >
          Spróbuj ponownie lub wróć na start.
        </Text>
        <Separator size="s" tone="invisible" />
      </div>
      <div className="flex gap-3 flex-col from-tablet:flex-row justify-center">
        <Link
          href={portalRoutes.mojeKonto.index.get({ mode: "mobile" })}
          passHref={true}
        >
          <A
            size={{
              "@onlyMobile": "s",
            }}
            variant="secondary"
          >
            wróć na start
          </A>
        </Link>
        <Button
          display="inline"
          onPress={refresh}
          size={{ "@onlyMobile": "s" }}
        >
          spróbuj ponownie
        </Button>
      </div>
    </Panel>
  );
}
